import {
  ADD_NOTIFICATION,
  UPDATE_NOTIFICATION,
  GET_NOTIFICATION_BY_USER,
  GET_NOTIFICATION_BY_SOURCE,
  GET_ARCHIVED_NOTIFICATION_BY_USER,
  APPEND_NOTIFICATION_BY_USER,
  GET_NOTIFICATION_UNREAD_COUNT,
  UPDATE_ALL_USER_NOTIFICATION,
  GET_ALL_ADMIN_NOTIFICATION,
  UPDATE_ADMIN_NOTIFICATION,
  UPDATE_ALL_ADMIN_NOTIFICATION,
  GET_ARCHIVED_ADMIN_NOTIFICATION,
  APPEND_ADMIN_NOTIFICATION,
  GET_ADMIN_NOTIFICATION_UNREAD_COUNT,
} from "../../actions/types";

const emptyPagination = { page: 1, hasMore: false, total: 0 };

function mergeWithoutDuplicates(existing, incoming) {
  const ids = new Set(existing.map((n) => n._id));
  return [...existing, ...incoming.filter((n) => n._id && !ids.has(n._id))];
}

const initialState = {
  notificationByUser: [],
  archivedNotificationByUser: [],
  notificationPagination: { ...emptyPagination },
  archivedNotificationPagination: { ...emptyPagination },
  numberNotificationNotRead: 0,
  allAdminNotification: [],
  archivedAdminNotification: [],
  adminNotificationPagination: { ...emptyPagination },
  archivedAdminNotificationPagination: { ...emptyPagination },
  adminNotificationNotRead: 0,
};

const boiteNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    // USER NOTIFICATION
    case ADD_NOTIFICATION:
      return {
        ...state,
        notificationByUser: [...state.notificationByUser, action.payload],
        numberNotificationNotRead:
          action.payload?.dejaVu !== true
            ? state.numberNotificationNotRead + 1
            : state.numberNotificationNotRead,
      };

    case GET_NOTIFICATION_BY_USER: {
      const { items, page, hasMore, total } = action.payload;
      return {
        ...state,
        notificationByUser: items,
        notificationPagination: { page, hasMore, total },
      };
    }

    case GET_ARCHIVED_NOTIFICATION_BY_USER: {
      const { items, page, hasMore, total } = action.payload;
      return {
        ...state,
        archivedNotificationByUser: items,
        archivedNotificationPagination: { page, hasMore, total },
      };
    }

    case APPEND_NOTIFICATION_BY_USER: {
      const { items, page, hasMore, total, archived } = action.payload;
      if (archived) {
        return {
          ...state,
          archivedNotificationByUser: mergeWithoutDuplicates(
            state.archivedNotificationByUser,
            items
          ),
          archivedNotificationPagination: { page, hasMore, total },
        };
      }
      const merged = mergeWithoutDuplicates(state.notificationByUser, items);
      return {
        ...state,
        notificationByUser: merged,
        notificationPagination: { page, hasMore, total },
      };
    }

    case GET_NOTIFICATION_UNREAD_COUNT:
      return {
        ...state,
        numberNotificationNotRead: action.payload?.count ?? 0,
      };

    case UPDATE_ALL_USER_NOTIFICATION: {
      const readAll = state.notificationByUser.map((el) => ({
        ...el,
        dejaVu: true,
      }));
      return {
        ...state,
        notificationByUser: readAll,
      };
    }

    case UPDATE_NOTIFICATION: {
      const updatedList = state.notificationByUser.map((el) =>
        el._id === action.payload._id
          ? { ...el, dejaVu: action.payload.dejaVu }
          : el
      );
      return {
        ...state,
        notificationByUser: updatedList,
      };
    }

    // ADMIN NOTIFICATION
    case GET_ALL_ADMIN_NOTIFICATION: {
      const { items, page, hasMore, total } = action.payload;
      return {
        ...state,
        allAdminNotification: items,
        adminNotificationPagination: { page, hasMore, total },
      };
    }

    case GET_ARCHIVED_ADMIN_NOTIFICATION: {
      const { items, page, hasMore, total } = action.payload;
      return {
        ...state,
        archivedAdminNotification: items,
        archivedAdminNotificationPagination: { page, hasMore, total },
      };
    }

    case APPEND_ADMIN_NOTIFICATION: {
      const { items, page, hasMore, total, archived } = action.payload;
      if (archived) {
        return {
          ...state,
          archivedAdminNotification: mergeWithoutDuplicates(
            state.archivedAdminNotification,
            items
          ),
          archivedAdminNotificationPagination: { page, hasMore, total },
        };
      }
      const merged = mergeWithoutDuplicates(state.allAdminNotification, items);
      return {
        ...state,
        allAdminNotification: merged,
        adminNotificationPagination: { page, hasMore, total },
      };
    }

    case GET_ADMIN_NOTIFICATION_UNREAD_COUNT:
      return {
        ...state,
        adminNotificationNotRead: action.payload?.count ?? 0,
      };

    case UPDATE_ALL_ADMIN_NOTIFICATION:
      return {
        ...state,
        allAdminNotification: state.allAdminNotification.map((el) => ({
          ...el,
          isRead: true,
        })),
      };

    case UPDATE_ADMIN_NOTIFICATION: {
      const updatedList = state.allAdminNotification.map((el) =>
        el._id === action.payload._id
          ? { ...el, isRead: action.payload.isRead }
          : el
      );
      return {
        ...state,
        allAdminNotification: updatedList,
      };
    }

    default:
      return state;
  }
};

export default boiteNotificationReducer;
